import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft, Search } from "lucide-react";
import { useEffect } from "react";

export default function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    console.warn("[NotFound] User hit 404:", {
      path: window.location.pathname,
      hash: window.location.hash,
      search: window.location.search,
    });
  }, []);

  const handleGoHome = () => {
    navigate("/home", { replace: true });
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/home", { replace: true });
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-background via-background to-primary/5"
      style={{
        paddingTop: "calc(1.5rem + var(--safe-area-top, 0px))",
        paddingBottom: "calc(1.5rem + var(--safe-area-bottom, 0px))",
      }}
    >
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="relative animate-in zoom-in duration-700">
          <div className="text-[120px] font-bold text-primary/10 leading-none select-none">404</div>
          <div className="absolute inset-0 flex items-center justify-center">
            <Search className="w-16 h-16 text-primary/40 animate-pulse" />
          </div>
        </div>

        <div className="space-y-3 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-100">
          <h1 className="text-3xl font-bold text-foreground">Page Not Found</h1>
          <p className="text-muted-foreground leading-relaxed">
            The page you're looking for doesn't exist or may have been moved.
          </p>
        </div>

        <div className="space-y-3 animate-in fade-in slide-in-from-bottom-6 duration-700 delay-200">
          <Button onClick={handleGoHome} className="w-full" size="lg">
            <Home className="w-4 h-4 mr-2" />
            Go to Home
          </Button>
          <Button onClick={handleGoBack} variant="outline" className="w-full" size="lg">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </Button>
        </div>

        <p className="text-xs text-muted-foreground animate-in fade-in duration-1000 delay-300">
          Lost? Head back to the home page to continue.
        </p>
      </div>
    </div>
  );
}